import { c as _c } from "react/compiler-runtime";
import './supporter-identity.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { InitialsAvatar } from '../../atoms/initials-avatar/initials-avatar.tsx';

/**
 * Shell placeholder shown while the real `SupporterIdentity` chunk loads.
 *
 * `SupporterIdentity` reaches `supporter-sdk` (query hooks, and the mock
 * fixtures those still statically import), so it is loaded lazily from
 * `nav-account.tsx` rather than bundled into the header chunk. This mirrors the
 * `minimal` and `dropdown` markup exactly so the swap costs no layout shift.
 *
 * `InitialsAvatar` falls back to the standard `user-01` icon when no initials
 * are supplied, which is precisely the shell state we want. Keep this file free
 * of `supporter-sdk` imports — that is the whole point of it.
 */
export const SupporterIdentityFallback: React.FC<{
  variant: 'minimal' | 'dropdown';
  size?: 'sm' | 'md' | 'lg';
  notificationCount?: number;
  className?: string;
}> = t0 => {
  const $ = _c(16);
  const {
    variant,
    size,
    notificationCount,
    className
  } = t0;
  if (variant === "minimal") {
    let t1;
    if ($[0] !== className) {
      t1 = cn("SupporterIdentity", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== notificationCount || $[3] !== size) {
      t2 = <InitialsAvatar notificationCount={notificationCount} size={size} />;
      $[2] = notificationCount;
      $[3] = size;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
      t3 = <div className={t1}>{t2}</div>;
      $[5] = t1;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t1;
  if ($[8] !== className) {
    t1 = cn("SupporterIdentity SupporterIdentity--dropdown flex flex-row gap-snug-xl items-center", className);
    $[8] = className;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== size) {
    t2 = <InitialsAvatar size={size} />;
    $[10] = size;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArkIcon iconName="chevron-down" size="20" className="label-neutral-mild lg:hidden" />;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};